import { useState } from "react";

/**
 * Phase 9.7.5 — Beam Safety Rules card.
 *
 * Always visible in every Live Room so participants and hosts know
 * the platform standards. Compact by default, expandable for the full
 * rule list. Hosts/monitors are reminded that they can remove rule
 * breakers.
 */
const RULES = [
  { emoji: "🚫", title: "No nudity or sexually explicit content" },
  { emoji: "🚫", title: "No hate speech or discrimination" },
  { emoji: "🚫", title: "No harassment, bullying, or threats" },
  { emoji: "🚫", title: "No scams, fraud, or self-promotion spam" },
  { emoji: "🚫", title: "No illegal content or substances" },
  { emoji: "🚫", title: "No copyright-infringing music or media" },
];

const BeamSafetyRules = ({ canModerate = false, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      data-testid="beam-safety-rules"
      className="rounded-xl border border-amber-400/30 bg-gradient-to-br from-amber-500/5 via-pink-500/5 to-purple-500/5 px-3 py-2"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 text-left"
        data-testid="beam-safety-rules-toggle"
        aria-expanded={open}
      >
        <span className="text-[10px] uppercase tracking-wider font-black text-amber-200">
          🛡️ Beam Safety & Rules
        </span>
        <span className="text-[10px] text-amber-100/80">{open ? "Hide ▴" : "Show ▾"}</span>
      </button>
      {open && (
        <div className="mt-2 space-y-1.5" data-testid="beam-safety-rules-list">
          {RULES.map((r) => (
            <div key={r.title} className="text-[11px] text-pink-100/90 flex items-start gap-1.5">
              <span>{r.emoji}</span>
              <span>{r.title}</span>
            </div>
          ))}
          <p className="text-[10px] text-amber-100/70 pt-2 border-t border-amber-400/20">
            {canModerate ? (
              <>As host or monitor you can mute, remove, or block any user breaking these rules.</>
            ) : (
              <>Hosts and monitors can mute, remove, or block users who break these rules. Please report serious violations to RGM Studio.</>
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default BeamSafetyRules;
